export default __webpack_public_path__ + "static/media/skipped3.1b59cc19.png";